/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 1000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Aditya Koshti",
  title: "Hey! Hi all, I'm Aditya",
  subTitle: emoji(
    "A passionate Full Stack Software Developer 🚀 having an experience of building Web and Mobile applications with JavaScript / Reactjs / Nodejs / MongoDB and some other cool libraries and frameworks."
  ),
  resumeLink:
    "https://drive.google.com/file/d/1ofFdKF_mqscH8WvXkSObnVvC9kK7Ldlu/view?usp=sharing", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/adityakoshti",
  linkedin: "https://www.linkedin.com/in/aditya-koshti-4a10251ba/",
  gmail: "adityadk1920@gmail.com",
  stackoverflow: "https://stackoverflow.com/",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "CRAZY FULL STACK DEVELOPER WHO WANTS TO EXPLORE EVERY TECH STACK",
  skills: [
    emoji(
      "⚡ Develop highly interactive Front end / User Interfaces for your web and mobile applications"
    ),
    emoji("⚡ Progressive Web Applications ( PWA ) in normal and SPA Stacks"),
    emoji(
      "⚡ Integration of third party services such as Firebase/ AWS / Digital Ocean"
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "html-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "sass",
      fontAwesomeClassname: "fab fa-sass"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "reactjs",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "nodejs",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "swift",
      fontAwesomeClassname: "fab fa-swift"
    },
    {
      skillName: "npm",
      fontAwesomeClassname: "fab fa-npm"
    },
    {
      skillName: "sql-database",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "aws",
      fontAwesomeClassname: "fab fa-aws"
    },
    {
      skillName: "firebase",
      fontAwesomeClassname: "fas fa-fire"
    },
    {
      skillName: "python",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "docker",
      fontAwesomeClassname: "fab fa-docker"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Indian Institute of Technology Goa",
      logo: require("./assets/images/Indian_Institute_of_Technology_Goa_Logo.svg"),
      subHeader: "Bachelors of Technology in Computer Science and Engineering",
      duration: "Aug 2020 - May 2024",
      desc: "High Achiever in the program. Took courses about Data Structures and Algorithms, Computer Networks, Operating Systems, Algorithm Design, Database Systems, Artificial Intelligence, Machine Learning, etc.",
      // descBullets: [
      //   "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      //   "Lorem ipsum dolor sit amet, consectetur adipiscing elit"
      // ]
    }
    // {
    //   schoolName: "Stanford University",
    //   logo: require("./assets/images/stanfordLogo.png"),
    //   subHeader: "Bachelor of Science in Computer Science",
    //   duration: "September 2013 - April 2017",
    //   desc: "Ranked top 10% in the program. ",
    //   descBullets: ["Lorem ipsum dolor sit amet, consectetur adipiscing elit"]
    // }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: false, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Frontend/Design", //Insert stack or technology you have experience in
      progressPercentage: "90%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Backend",
      progressPercentage: "70%"
    },
    {
      Stack: "Programming",
      progressPercentage: "60%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "(Upcoming) Software Engineer Intern",
      company: "ARM",
      companylogo: require("./assets/images/arm_logo.png"),
      date: "2023",
      desc: "Selected in the Summer Internship Program of ARM, Bangalore, India",
      descBullets: [
        "Will be working on the development of a ARM architecture based processor for the next generation of IoT devices.",
        "Also be working with languages such as python and C++."
      ]
    },
    {
      role: "WAGS - Summer Intern",
      company: "Indian Institute of Tecahnology, Goa",
      companylogo: require("./assets/images/white_logo_iitgoa.webp"),
      date: "March   2022 – May 2022",
      desc: "Engaged in a 2 month Summer Internship in App Development project under the guidance of Dr. Neha Karanjkar",
      descBullets: [
      "Team of 5 developers, aims to connect a link between volunteers, with needy stray animals in locality of Goa.",
      "Task was to build a backend API to connect frontend with real-time backend database and test the APIs filter and searching, secure datatbase development with SSL encryption certificates.",
      "Gained experience in Firebase Real-time Database/NoSQL, NodeJs, DBMS and REST APIs development, Cloud Hosting."
      ]
    },
    {
      role: "Backend Developer",
      company: "Cepheus/Cultrang Technical Fest",
      companylogo: require("./assets/images/cepheus_logo.jpeg"),
      date: "2022 – 2023",
      desc: "Created the backend registration of a National Level Annual Cultural/Tech Fest with Node JS and MongoDB with 7+ teammates.",
      descBullets: [
      "This Website attains a Traffic of over 2000 participants over 4-5 weeks.",
      "Website does the user authentication and sends the auto-generated mail after successful registration for all competitions."
      ]
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Big Projects",
  subtitle: "SOME PERSONAL PROJECTS AND START-UP PROJECTS THAT I HELPED TO CREATE THEIR TECH",
  projects: [
    {
      image: require("./assets/images/Meetra_logo.png"),
      projectName: "Video-Conferencing Web Application (Meet-ra)", 
      projectDesc: "Incorporated a Live Video Conferencing Web App which provides secure connection with peers built on Socket.io and PeerJs (library over WebRTC).",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://meet-bf2x.onrender.com/"
        },
        {
          name: "Visit Github",
          url: "https://github.com/AdityaKoshti/MEET-RA"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/paw.png"),
      projectName: "WAGS(Welfare And Guidance for Stray) Backend",
      projectDesc: "Build a backend API to connect frontend with real-time backend database and test the APIs filter and searching, secure datatbase development with SSL encryption certificates.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://stray-welfare-iitgoa.github.io/WAGS/index.html"
        }
      ]
    },
    {
      image: require("./assets/images/key-solid.svg"),
      projectName: "Secrets- Authentication and Security",
      projectDesc: "This is an Authentication site which is build over Google OAuth2.0 and Database Encryption using PassportJS",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://secrets-zvij.onrender.com/"
        },
        {
          name: "Visit Github",
          url: "https://github.com/AdityaKoshti/Secrets"
        }
      ]
    },
    {
      image: require("./assets/images/check-list.png"),
      projectName: "Task Manager",
      projectDesc: "A user-friendly Web App using EJS, JavaScript, NodeJS, MongoDB, FireBase Auth, where users can manage their Task",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://tranquil-caverns-50236.herokuapp.com/"
        }
      ]
    }
    
  ],
  display: true // Set false to hide this section, defaults to true
};


const achievementSection = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Event Head - Coding Hackathon",
      company: "HackOverFlow",
      companylogo: require("./assets/images/cepheus_logo.jpeg"),
      date: "Jan 2023 - Feb 2023",
      desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
      descBullets: [
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit"
      ]
    },
    {
      role: "Core Member - Develpment Club",
      company: "Cepheus/Cultrang Technical Fest",
      companylogo: require("./assets/images/architech_logo.jpeg"),
      date: "Aug 2021 - Present",
      desc: "Created the backend registration of a National Level Annual Cultural/Tech Fest with Node JS and MongoDB with 7+ teammates.",
      descBullets: [
      "This Website attains a Traffic of over 2000 participants over 4-5 weeks.",
      "Website does the user authentication and sends the auto-generated mail after successful registration for all competitions."
      ]
    }
  ]
};
// Achievement Section
// Include certificates, talks etc

// const achievementSection = {
//   title: emoji("Achievements And Certifications 🏆 "),
//   subtitle:
//     "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

//   achievementsCards: [
//     {
//       title: "Google Code-In Finalist",
//       subtitle:
//         "",
//       image: require("./assets/images/codeInLogo.webp"),
//       imageAlt: "Google Code-In Logo",
//       footerLink: [
//         {
//           name: "Certification",
//           url: "https://drive.google.com/file/d/0B7kazrtMwm5dYkVvNjdNWjNybWJrbndFSHpNY2NFV1p4YmU0/view?usp=sharing"
//         },
//         {
//           name: "Award Letter",
//           url: "https://drive.google.com/file/d/0B7kazrtMwm5dekxBTW5hQkg2WXUyR3QzQmR0VERiLXlGRVdF/view?usp=sharing"
//         },
//         {
//           name: "Google Code-in Blog",
//           url: "https://opensource.googleblog.com/2019/01/google-code-in-2018-winners.html"
//         }
//       ]
//     },
//     {
//       title: "Google Assistant Action",
//       subtitle:
//         "Developed a Google Assistant Action JavaScript Guru that is available on 2 Billion devices world wide.",
//       image: require("./assets/images/googleAssistantLogo.webp"),
//       imageAlt: "Google Assistant Action Logo",
//       footerLink: [
//         {
//           name: "View Google Assistant Action",
//           url: "https://assistant.google.com/services/a/uid/000000100ee688ee?hl=en"
//         }
//       ]
//     },

//     {
//       title: "PWA Web App Developer",
//       subtitle: "Completed Certifcation from SMIT for PWA Web App Development",
//       image: require("./assets/images/pwaLogo.webp"),
//       imageAlt: "PWA Logo",
//       footerLink: [
//         {name: "Certification", url: ""},
//         {
//           name: "Final Project",
//           url: "https://pakistan-olx-1.firebaseapp.com/"
//         }
//       ]
//     }
//   ],
//   display: true // Set false to hide this section, defaults to true
// };

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle1:
    "My Inbox is open for all. Will be happy to connect with you.",
  subtitle2:
    "Aditya Koshti | Computer Science and Engineering, IIT Goa | Full Stack Developer | Competitive Programmer | Open Source Enthusiast",
  email_address: "adityadk1920@gmail.com",
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const isHireable = false; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable
};
